import { Button } from 'ui';
import { DataConfigType } from 'routes/logged-in/collection-data-configs/CreateCollectionDataConfigRoute';
import { StoreType, useActions } from 'utils/connect';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import { consumer } from '@tock/coretypes';
import { useMountEffect } from '@tock/hooks';
import { useRouteMatch } from 'react-router';
import { useSelector } from 'react-redux';
import AnchorV2 from 'components/AnchorV2';
import Edit from '@mui/icons-material/Edit';

interface CollectionDataConfigsListProps {
  dataConfigType: DataConfigType;
}

const CollectionDataConfigsList: React.FunctionComponent<
  React.PropsWithChildren<CollectionDataConfigsListProps>
> = ({ dataConfigType }) => {
  const match = useRouteMatch();
  const { actions } = useActions();
  const collectionDataConfigurations = useSelector(
    (state: StoreType) => state.consumerPage.collectionDataConfigurations || []
  );

  useMountEffect(() => {
    actions.consumerPage.fetchAllCollectionDataConfigurations();
  });

  const filterConfigsByType = (config: consumer.ICollectionDataConfiguration) => {
    switch (dataConfigType) {
      case 'businessCollection': {
        return !!config.collectionConfig;
      }
      case 'businessLucene': {
        return !!config.businessLuceneSearch;
      }
      case 'experienceLucene': {
        return !!config.experienceLuceneSearch;
      }
      default:
        return false;
    }
  };

  return (
    <TableContainer>
      <Table aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell align="left" sx={{ fontWeight: (theme) => theme.typography.fontWeightBold }}>
              Name
            </TableCell>
            <TableCell
              align="right"
              sx={{ fontWeight: (theme) => theme.typography.fontWeightBold }}
            >
              Actions
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {collectionDataConfigurations.filter(filterConfigsByType).map(({ name, id }) => (
            <TableRow key={id}>
              <TableCell align="left">{name}</TableCell>
              <TableCell align="right">
                <Button component={AnchorV2} href={`${match.path}/edit/${id}`} endIcon={<Edit />}>
                  Edit
                </Button>
                {/* <Button
                  endIcon={<IconTrash />}
                  variant="outlined"
                  color="danger"
                  onClick={() => onArchiveWidget(id)}
                  className={classes.button}
                >
                  Archive
                </Button> */}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default CollectionDataConfigsList;
